import {
  FavoriteActionsTypes,
  FavoriteState,
  GET_CARTS_FOR_USER_SUCCESS,
  UPDATE_CART,
} from "./types";

export const initialState: FavoriteState = {
  collection: null,
  loading: false,
};

const reducer = (
  state: FavoriteState = initialState,
  action: FavoriteActionsTypes
) => {
  const stateCopy: FavoriteState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case GET_CARTS_FOR_USER_SUCCESS: {
      const favorite = action.payload.find((cart) => cart.name === "Favorites");
      if (favorite) stateCopy.collection = favorite;
      return stateCopy;
    }
    case UPDATE_CART: {
      stateCopy.collection = action.payload;
      return stateCopy;
    }
    default: {
      return stateCopy;
    }
  }
};

export default reducer;
